export const enhanceZammadModal = (modal: Element) => {
  if (!(modal instanceof HTMLElement)) {
    return;
  }
  if (modal.dataset.smartefbActions === "1") {
    return;
  }
  const form = modal.querySelector("form.zammad-form");
  const submit = form?.querySelector<HTMLButtonElement>('button[type="submit"]');
  if (!form || !submit) {
    return;
  }
  modal.dataset.smartefbActions = "1";
  if (submit.textContent?.trim() === "Sent") {
    submit.textContent = "Send";
  }

  const ownerDocument = modal.ownerDocument;
  const row = ownerDocument.createElement("div");
  row.className = "zammad-form-actions";
  const cancel = ownerDocument.createElement("button");
  cancel.type = "button";
  cancel.className = "btn zammad-form-cancel";
  cancel.textContent = "Cancel";
  cancel.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    modal.remove();
  });
  submit.parentNode?.insertBefore(row, submit);
  row.appendChild(cancel);
  row.appendChild(submit);
};

export const observeZammadModals = (root: ParentNode) => {
  const enhanceTree = (node: ParentNode | Element) => {
    if (node instanceof Element && node.matches(".zammad-form-modal")) {
      enhanceZammadModal(node);
    }
    node.querySelectorAll?.(".zammad-form-modal").forEach(enhanceZammadModal);
  };
  enhanceTree(root);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          enhanceTree(node);
        }
      });
    });
  });
  observer.observe(root, { childList: true, subtree: true });
  return observer;
};
